import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import bgTranslation from './bg.json';
import csTranslation from './cs.json';
import daTranslation from './da.json';
import deatTranslation from './de-at.json';
import deTranslation from './de-de.json';
import enTranslation from './en.json';
import enAuTranslation from './en-AU.json';
import enGBTranslation from './en-GB.json';
import esTranslation from './es.json';
import fiTranslation from './fi.json';
import frTranslation from './fr.json';
import hrTranslation from './hr.json';
import huTranslation from './hu.json';
import itTranslation from './it.json';
import nlTranslation from './nl.json';
import plTranslation from './pl.json';
import roTranslation from './ro.json';
import skTranslation from './sk.json';
import slTranslation from './sl.json';
import srTranslation from './sr.json';
import svTranslation from './sv.json';
import { 
  COUNTRY_NAME_AND_CODE_MAP, 
  DEFAULT_LANGUAGE,
  DEFAULT_TRANSLATION_MARKET
} from 'shared/constants';
import { getLocaleString } from 'shared/utils/getLocaleString';

const languageTranslations = {
  en: enTranslation,
  'en-AU': enAuTranslation,
  'en-GB': enGBTranslation,
  nl: nlTranslation,
  es: esTranslation,
  bg: bgTranslation,
  cs: csTranslation,
  da: daTranslation,
  'de-DE': deTranslation,
  'de-AT': deatTranslation,
  fi: fiTranslation,
  fr: frTranslation,
  hr: hrTranslation,
  hu: huTranslation,
  it: itTranslation,
  pl: plTranslation,
  ro: roTranslation,
  sk: skTranslation,
  sl: slTranslation,
  'sr-Latn': srTranslation,
  sv: svTranslation
};

function remapTranslations() {

  // This maps the current languageCode: { 'countryName': translations } setup 
  // To a more managable languageCode-countryCode: { translations } version
  const tempArray = Object.entries(languageTranslations).map(
    ([langKey, translationList]) => Object.fromEntries(
        Object.entries(translationList)
          .map(([key, val]) => [getLocaleString(langKey,COUNTRY_NAME_AND_CODE_MAP[key]), { translation: val }])
      )
  );
  
  return Object.assign({}, ...tempArray);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: remapTranslations(),
    load: 'all',
    fallbackLng: getLocaleString(DEFAULT_LANGUAGE, DEFAULT_TRANSLATION_MARKET),
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
